/**
 * @generated SignedSource<<eaa9c1bab991e8bf0f3f749a5cafe640>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailsTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
  readonly " $fragmentType": "PdpRespDetailsTabs_viewer";
};
export type PdpRespDetailsTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailsTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailsTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailsTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "85f85ca29f68624a16408eb5ef628bba";

export default node;
